import { RootState } from '@next/core-lib/app';
import { SettingsDataObject } from '@next/core-lib/settings';
import { EntityState } from '@ngrx/entity';

import { AnimalType, Product } from '../../shared/models';

export interface ReferenceSchemeModuleState extends RootState {
  referenceSchemes?: ReferenceSchemeState;
  products?: Product[];
  selectedCountry?: string;
  isLoaded: boolean;
}

export type ReferenceSchemeState = EntityState<ReferenceScheme>;

export interface ReferenceScheme extends SettingsDataObject {
  id?: number;
  customerId: number;
  updatedAdvisorProfileId: number;
  createdAdvisorProfileId: number;
  updatedAdvisorName: string;
  createdAdvisorName: string;
  locationIds: number[];
  name: string;
  description: string;
  isActive: boolean;
  updated: string;
  created: string;
  productRows: ProductRow[];
  additiveRows: AdditiveRow[];
  isReferenceScheme: boolean;
  country: string;
  referenceSchemeId: number;
  animalType: AnimalType;
}

export interface ProductRow extends SettingsDataObject {
  id?: number;
  product: Product;
  chickenWeightInGrams?: number;
  ageFrom: number;
  ageTo: number;
  totalFeed: number;
  coreFeed?: number;
  wheatFeed?: number;
  comment?: string;
}

export interface AdditiveRow extends SettingsDataObject {
  id?: number;
  product: Product;
  dosage?: number;
  applicationMoment?: string;
  comment?: string;
}

export interface GetReferenceSchemesResponse {
  referenceSchemes: ReferenceScheme[];
}

export interface UpsertReferenceSchemeResponse {
  id?: number;
}

export enum ViewMode {
  View,
  Create,
  Edit,
}
